import { EndpointCardListCombinedProps } from './types';

const usePresenter = (props: EndpointCardListCombinedProps): EndpointCardListCombinedProps => {
  return props;
};

export default usePresenter;
